// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'reducers';

import { setAuthorizationToken } from 'utils/setAuthorizationToken';
import { tokenLogin, FIREBASE_LOGIN } from 'actions/auth';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';

import 'moment/locale/de-at';
import moment from 'moment';
moment().locale('de-at');

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';

// Containers
import Full from 'containers/Full';

// Views
import Login from 'pages/Login';

import requireAuth from 'utils/requireAuth';

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension && process.env.NODE_ENV !== 'production'
      ? window.devToolsExtension()
      : f => f
  )
);

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDkQ6TVn78OQD0hCR0f42q9a4zLVSaEGsE',
  authDomain: 'zuzu-1541317122162.firebaseapp.com',
  databaseURL: 'https://zuzu-1541317122162.firebaseio.com',
  projectId: 'zuzu-1541317122162',
  storageBucket: 'zuzu-1541317122162.appspot.com',
  messagingSenderId: '491471599606',
  appId: '1:491471599606:web:1f75860a9b84c6828879d7',
  measurementId: 'G-21ZP37MFE0',
};
firebase.initializeApp(FIREBASE_CONFIG);

const token = localStorage.getItem('userToken');
if (token) {
  console.log('auth token set');
  setAuthorizationToken(token);
  store.dispatch(tokenLogin(token));
}

firebase.auth().onAuthStateChanged(async user => {
  if (!!user) {
    const userData = await (
      await firebase
        .firestore()
        .doc(`users/${user.uid}`)
        .get()
    ).data();

    store.dispatch({
      type: FIREBASE_LOGIN,
      payload: {
        uid: user.uid,
        email: user.email,
        ...userData,
      },
    });
  }
});
if (process.env.NODE_ENV !== 'production') {
  firebase.functions().useFunctionsEmulator('http://localhost:5000');
}

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <Switch>
        <Route
          exact
          path="/login"
          name="zuzu.at Administration"
          component={Login}
        />
        <Route path="/" name="Home" component={requireAuth(Full)} />
        <Route component={Login} />
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js